/* SHZ location autofill - fills Shopify checkout address from the shopper's location.
   Flow: geolocation (stored 12h) -> Google reverse geocode -> cart attributes ->
   on "checkout" we redirect to /checkout?checkout[shipping_address][...] (prefill). */
(function () {
  'use strict';
  var C = window.SHZ_LOC || {};
  if (!C.key) return;

  var LS = 'shz_loc_v1';
  var TTL = 12 * 60 * 60 * 1000;
  var SHORT = /^[A-Z]{4}\d{4}$/;
  var root = (C.root || '/').replace(/\/$/, '');

  function load() { try { return JSON.parse(localStorage.getItem(LS) || 'null'); } catch (e) { return null; } }
  function save(o) { try { localStorage.setItem(LS, JSON.stringify(o)); } catch (e) {} }
  var state = load() || {};

  /* ---------- Google Maps loader ---------- */
  var mapsPromise = null;
  function loadMaps() {
    if (mapsPromise) return mapsPromise;
    mapsPromise = new Promise(function (resolve, reject) {
      if (window.google && google.maps && google.maps.Geocoder) return resolve();
      window.__shzMapsReady = function () { resolve(); };
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(C.key) +
        '&language=ar&region=SA&callback=__shzMapsReady';
      s.async = true;
      s.onerror = function () { mapsPromise = null; reject(new Error('maps load')); };
      document.head.appendChild(s);
    });
    return mapsPromise;
  }

  /* ---------- Reverse geocode ---------- */
  function parse(results) {
    var first = {}, any = {};
    results[0].address_components.forEach(function (c) { c.types.forEach(function (t) { first[t] = c; }); });
    results.forEach(function (r) { r.address_components.forEach(function (c) { c.types.forEach(function (t) { if (!any[t]) any[t] = c; }); }); });
    function g(t, s) { var c = first[t] || any[t]; return c ? (s ? c.short_name : c.long_name) : ''; }

    var shortCode = '';
    results.some(function (r) {
      return r.address_components.some(function (c) {
        var v = String(c.short_name || c.long_name || '').replace(/\s/g, '').toUpperCase();
        if (SHORT.test(v)) { shortCode = v; return true; }
        return false;
      });
    });

    var district = g('sublocality_level_1') || g('sublocality') || g('neighborhood');
    var street = [g('street_number'), g('route')].filter(Boolean).join(' ');
    var zip = g('postal_code');
    if (!/^\d{5}$/.test(zip)) zip = '';
    return {
      address1: [street, district].filter(Boolean).join('، ') || results[0].formatted_address,
      district: district,
      city: g('locality') || g('administrative_area_level_2') || g('administrative_area_level_1'),
      zip: zip,
      country: g('country', true),
      shortCode: shortCode,
      formatted: results[0].formatted_address
    };
  }

  function geocode(lat, lng) {
    return loadMaps().then(function () {
      return new Promise(function (resolve, reject) {
        new google.maps.Geocoder().geocode({ location: { lat: lat, lng: lng } }, function (res, status) {
          if (status === 'OK' && res && res.length) resolve(parse(res)); else reject(new Error(status));
        });
      });
    });
  }

  function ensureAddress() {
    if (!state.lat || state.optOut) return Promise.resolve(null);
    if (state.addr && state.addrFor === state.lat + ',' + state.lng) return Promise.resolve(state.addr);
    return geocode(state.lat, state.lng).then(function (a) {
      state.addr = a; state.addrFor = state.lat + ',' + state.lng; save(state);
      pushCartAttributes();
      render();
      return a;
    });
  }

  /* ---------- Cart attributes (show on the order for the courier) ---------- */
  function pushCartAttributes() {
    if (!state.lat) return;
    var a = state.addr || {};
    var attrs = {
      latitude: String(state.lat),
      longitude: String(state.lng),
      'موقع العميل': 'https://maps.google.com/?q=' + state.lat + ',' + state.lng
    };
    if (a.shortCode) attrs.national_address = a.shortCode;
    fetch(root + '/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  /* ---------- Geolocation ---------- */
  function locate(done) {
    if (!('geolocation' in navigator)) return done && done(false, 'المتصفح ما يدعم تحديد الموقع');
    navigator.geolocation.getCurrentPosition(function (p) {
      state = { lat: +p.coords.latitude.toFixed(6), lng: +p.coords.longitude.toFixed(6), ts: Date.now() };
      save(state);
      pushCartAttributes();
      if (!done && C.template === 'cart') ensureAddress().catch(function (e) { ui.msg = geoErr(e); render(); });
      done && done(true);
    }, function (err) {
      var denied = err && err.code === 1;
      if (denied) { state.deniedTs = Date.now(); save(state); }
      done && done(false, denied ? 'فعّلي إذن الموقع من إعدادات المتصفح وحاولي مرة ثانية' : 'ما قدرنا نحدد موقعك، حاولي مرة ثانية');
    }, { enableHighAccuracy: true, timeout: 15000, maximumAge: 10 * 60 * 1000 });
  }

  var fresh = state.ts && (Date.now() - state.ts < TTL);
  var recentlyDenied = state.deniedTs && (Date.now() - state.deniedTs < TTL);
  if (C.askOnLoad && !C.designMode && !fresh && !recentlyDenied) locate();

  /* ---------- Checkout prefill ---------- */
  function checkoutUrl(a) {
    var p = [];
    function add(k, v) { if (v) p.push('checkout[shipping_address][' + k + ']=' + encodeURIComponent(v)); }
    if (a.country === 'SA') add('country', 'SA');
    add('address1', a.address1);
    add('address2', a.shortCode);
    add('city', a.city);
    add('zip', a.zip);
    return root + '/checkout' + (p.length ? '?' + p.join('&') : '');
  }

  function goCheckout(form, fallback) {
    var withTimeout = Promise.race([
      ensureAddress(),
      new Promise(function (r) { setTimeout(function () { r(null); }, 3500); })
    ]).catch(function () { return null; });
    var saveCart = form ? fetch(root + '/cart/update.js', { method: 'POST', body: new FormData(form) }).catch(function () {}) : Promise.resolve();
    Promise.all([withTimeout, saveCart]).then(function (r) {
      var a = r[0];
      if (a && a.address1 && a.country === 'SA') window.location.href = checkoutUrl(a);
      else fallback();
    });
  }

  document.addEventListener('submit', function (e) {
    if (!state.lat || state.optOut) return;
    var f = e.target, sub = e.submitter;
    var isCheckout = (sub && sub.name === 'checkout') || (f.action && /\/checkout/.test(f.action));
    if (!isCheckout) return;
    e.preventDefault();
    goCheckout(f, function () {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = 'checkout'; i.value = '1';
      f.appendChild(i); HTMLFormElement.prototype.submit.call(f);
    });
  }, true);

  document.addEventListener('click', function (e) {
    if (!state.lat || state.optOut) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!/^(\/[a-z-]*)?\/checkout(\?|$)/.test(href.replace(location.origin, ''))) return;
    e.preventDefault();
    goCheckout(null, function () { window.location.href = href; });
  }, true);

  /* ---------- Cart page box ---------- */
  var ui = { msg: '', busy: false };
  var BTN = 'display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:13px 16px;border:0;border-radius:10px;background:#80201f;color:#fff;font-size:15px;font-weight:700;cursor:pointer;font-family:inherit';
  function findHost() {
    var h = document.querySelector('.m-cart__checkout') ||
      document.querySelector('#MinimogCartFooter [name="checkout"]') ||
      document.querySelector('form[action*="/cart"] [name="checkout"]');
    if (h && h.tagName === 'BUTTON') h = h.parentElement;
    return h;
  }
  function render() {
    if (C.template !== 'cart') return;
    var box = document.getElementById('shz-loc-box');
    var a = state.addr;
    var ok = state.lat && !state.optOut && a && a.country === 'SA';
    var pending = state.lat && !state.optOut && !a && !ui.msg && !ui.busy;
    if (ok || pending) { if (box) box.remove(); return; }   /* location known: silent. Not allowed yet: show the message + button */
    var host = findHost();
    if (!host) return;
    if (!box) {
      box = document.createElement('div');
      box.id = 'shz-loc-box';
      box.style.cssText = 'margin:0 0 14px;padding:12px;border:1px solid #eadada;border-radius:12px;background:#fbf7f7;text-align:center;direction:rtl';
      host.parentNode.insertBefore(box, host);
    }
    box.innerHTML = '<div style="font-size:14px;margin-bottom:10px">عبّي عنوانك تلقائيًا بضغطة وحدة</div>' +
      '<button type="button" id="shz-loc-btn" style="' + BTN + '"' + (ui.busy ? ' disabled' : '') + '>' +
      (ui.busy ? 'جاري تحديد عنوانك…' : '📍 استخدام موقعي') + '</button>' +
      (ui.msg ? '<div style="font-size:13px;color:#a33;margin-top:6px">' + esc(ui.msg) + '</div>' : '');
    var btn = document.getElementById('shz-loc-btn');
    if (btn) btn.onclick = function (ev) {
      ev.preventDefault();
      if (ui.busy) return;
      ui.busy = true; ui.msg = ''; render();
      locate(function (ok, err) {
        if (!ok) { ui.busy = false; ui.msg = err; render(); return; }
        ensureAddress().then(function (addr) {
          ui.busy = false;
          if (addr && addr.country !== 'SA') ui.msg = 'موقعك خارج السعودية – بتكتبين العنوان في صفحة الدفع';
          render();
        }).catch(function (e) { ui.busy = false; ui.msg = geoErr(e); render(); });
      });
    };
  }
  function geoErr(e) { return 'تعذّر تحديد العنوان (' + (e && e.message ? e.message : e || 'error') + ')'; }
  window.gm_authFailure = function () { ui.busy = false; ui.msg = geoErr('Google key'); render(); };
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  if (C.template === 'cart') {
    var start = function () {
      render(); ensureAddress().catch(function (e) { ui.msg = geoErr(e); render(); });
      var t; new MutationObserver(function () {
        if (document.getElementById('shz-loc-box') || (state.lat && !state.optOut && !ui.msg)) return;
        clearTimeout(t); t = setTimeout(render, 150);
      }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  }

  /* test hook */
  window.SHZ_LOC_TEST = {
    setCoords: function (lat, lng) { state = { lat: lat, lng: lng, ts: Date.now() }; save(state); render(); return ensureAddress(); },
    state: function () { return state; },
    url: function () { return state.addr ? checkoutUrl(state.addr) : null; }
  };
})();
